import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { generateComparePDF, generateSalvagePDF } from '../../utils/api';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Generate = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

    const handleMarketList = () => {
        let data = JSON.parse(localStorage.getItem("formValues"))
        const { make, model, trim, city } = data;
        if (data) {
            navigate('/find_car?update=true', {
                state: { formInputValues: data, filterInput: { make, model, trim, city } },
            })
        }
    }
    const handleSalvageList = () => {
        navigate("/find_salvageCar");
    }
    const handleForm = () => {
        let keysToRemove = ["compareCars", "formValues", "salvageCars", "marketCars", "filters", "compareSalvage"];
        keysToRemove.forEach(k => localStorage.removeItem(k))
        navigate("/form_page");
    }

    const handleGenerate = () => {
        setLoading(true);
        let compareCars = JSON.parse(localStorage.getItem("marketCars"));
        let inputValues = JSON.parse(localStorage.getItem("formValues"));
        let salvageCars = JSON.parse(localStorage.getItem("salvageCars"));
    
        Promise.all([
            generateComparePDF({ slectedCars: compareCars, marketValueList: inputValues }),
            generateSalvagePDF(salvageCars)
        ])
        .then(([comparePDF, salvagePDF]) => {
            // Create Blob URLs for both PDFs
            const compareURL = window.URL.createObjectURL(new Blob([comparePDF.data], { type: 'application/pdf' }));
            const salvageURL = window.URL.createObjectURL(new Blob([salvagePDF.data], { type: 'application/pdf' }));
            // Open both PDFs in new tabs
            window.open(compareURL);
            window.open(salvageURL);
            localStorage.removeItem("compareCars");
            let keysToRemove = ["compareCars", "formValues", "salvageCars", "marketCars", "filters", "compareSalvage"];
            keysToRemove.forEach(k => localStorage.removeItem(k));
            setTimeout(()=>{
                navigate("/");
            },2000)
        })
        .catch(() => {
            setLoading(false);
        });
    };
    

    return (
        <Spin
      spinning={loading}
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 48,
            color: 'black',
          }}
          spin
        />
      }
    >
        <div className='flex justify-center'>
            <div className='w-full md:w-[80%] lg:w-[50%] flex flex-col p-10 md:p-20 lg:p-[115px]'>
                <button className={`bg-[#34aeeb] px-[52px] py-[25px] text-white text-lg mb-[31px]`} onClick={handleMarketList} >
                    Update Market Value List
                </button>
                <button className={`bg-[#34aeeb] px-[52px] py-[25px] text-white text-lg mb-[31px]`} onClick={handleSalvageList} >
                    Update Salvage Value List
                </button>
                <button className={`bg-[#499153] px-[52px] py-[25px] text-white text-lg mb-[31px]`} onClick={handleGenerate}>
                    Generate Condition Report
                </button>
                <button className={`bg-[#34aeeb] px-[52px] py-[25px] text-white text-lg `} onClick={handleForm}>
                    Start New Evaluation
                </button>
            </div>
        </div>
        </Spin>
    )
}

export default Generate
